// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToolOutlinedSvg from "@ant-design/icons-svg/es/asn/ToolOutlined";
import AntdIcon from '../components/AntdIcon';

var ToolOutlined = function ToolOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ToolOutlinedSvg
  }));
};

ToolOutlined.displayName = 'ToolOutlined';
export default React.forwardRef(ToolOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ToolOutlined.js
// module id = 1943
// module chunks = 0